import { PageContainer } from "../components/PageContainer";
import { ParentSignupForm } from "../components/SignupForms/ParentSignupForm";

export const ParentSignup = () => {
  return (
    <PageContainer>
      <ParentSignupForm />
    </PageContainer>
  );
};
